import React from "react";
import "./index.css";
import Navbar from "../../Components/Navbar";
import HeroSection from "../../Components/HeroSection";
import UserProfile from "../../Components/UserProfile";
import Description from "../../Components/Description";
import Footer from "../../Components/Footer";

function Home() {
  return (
    <>
      <Navbar />
      <HeroSection />
      <section className="w-100 bg-[#ffff] p-5">
        <UserProfile />
        <Description />
      </section>
      <Footer />
    </>
  );
}

export default Home;
